// extracted by mini-css-extract-plugin
export default {"form":"EGoxO","dialog":"IMXB2","button":"lKtft","logo":"kr1FX","header":"z3feh","image":"WC3Yf","title":"_MRL7","clarification":"pOM4t"};